import { DeviceCapability } from './DeviceCapability.ts';

export const zoneActivityCapabilities = new Set([
  DeviceCapability.AlarmMotion,
  DeviceCapability.AlarmContact,
  DeviceCapability.AlarmVibration,
  DeviceCapability.AlarmOccupancy,
  DeviceCapability.AlarmPresence,
]);
